
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.174 8a.99.99 0 00.992.984c.276 0 .5.222.5.496v1.784c0 1.509-1.238 2.736-2.761 2.736h-7.81c-1.523 0-2.762-1.227-2.762-2.736V9.48c0-.274.224-.496.5-.496a.99.99 0 00.993-.983c0-.529-.427-.926-.993-.926a.501.501 0 01-.5-.496l.001-1.842C1.334 3.228 2.573 2 4.096 2h7.808c1.522 0 2.762 1.228 2.762 2.737v1.785a.494.494 0 01-.5.495.99.99 0 00-.992.984zM9.5 8.433l.786-.758a.487.487 0 00-.273-.833l-1.086-.158-.486-.975a.491.491 0 00-.441-.272H8a.493.493 0 00-.442.272l-.486.975-1.084.157a.49.49 0 00-.4.332.483.483 0 00.124.502l.786.758-.185 1.072a.485.485 0 00.197.48.5.5 0 00.518.035L8 9.513l.97.505c.168.09.367.075.52-.036a.482.482 0 00.197-.478l-.186-1.072z","fill":"var(--primary)"}})])
          )
        }
      }
    